const DEFAULT_API_URL = "https://localhost:5001";

export const getApiBaseUrl = () => {
  const configuredBaseUrl = process.env.REACT_APP_API_URL;
  const resolvedBaseUrl = configuredBaseUrl || DEFAULT_API_URL;

  return resolvedBaseUrl.replace(/\/+$/, "");
};

const getErrorMessageFromPayload = (errorPayload) => {
  if (!errorPayload || typeof errorPayload !== "object") {
    return "Failed to submit contact lead.";
  }

  if (typeof errorPayload.message === "string" && errorPayload.message.trim()) {
    return errorPayload.message;
  }

  if (typeof errorPayload.title === "string" && errorPayload.title.trim()) {
    const errors = errorPayload.errors;
    if (errors && typeof errors === "object") {
      const validationMessages = Object.values(errors)
        .flatMap((value) => (Array.isArray(value) ? value : []))
        .filter((value) => typeof value === "string" && value.trim());

      if (validationMessages.length > 0) {
        return validationMessages.join(" ");
      }
    }

    return errorPayload.title;
  }

  return "Failed to submit contact lead.";
};

export const submitContactLead = async (payload) => {
  const response = await fetch(`${getApiBaseUrl()}/api/contact`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      FullName: payload.FullName,
      Email: payload.Email,
      Phone: payload.Phone,
      ProjectType: payload.ProjectType,
      Message: payload.Message,
    }),
  });

  if (!response.ok) {
    let errorMessage = "Failed to submit contact lead.";

    try {
      const responseContentType = response.headers.get("content-type") || "";

      if (responseContentType.includes("application/json")) {
        const errorPayload = await response.json();
        errorMessage = getErrorMessageFromPayload(errorPayload);
      } else {
        const errorText = await response.text();
        if (errorText.trim()) {
          errorMessage = errorText.trim();
        }
      }
    } catch {
      // Ignore parse errors and keep fallback message.
    }

    throw new Error(errorMessage);
  }

  if (response.status === 204) {
    return null;
  }

  const responseContentType = response.headers.get("content-type") || "";

  if (responseContentType.includes("application/json")) {
    return response.json();
  }

  return response.text();
};
